import React from 'react';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

export const LoginRequiredDialog = ({
	alertOpen,
	setAlertOpen,
}: {
	alertOpen: boolean;
	setAlertOpen: (open: boolean) => void;
}) => {
	const t = useTranslations('loginDialog');

	const oidcIssuer = process.env.NEXT_PUBLIC_OIDC_ISSUER_URL;
	const oidcClientId = process.env.NEXT_PUBLIC_OIDC_CLIENT_ID || 'qrcodly';
	const frontendUrl = process.env.NEXT_PUBLIC_FRONTEND_URL || 'https://qr.dslan.at';
	const signInHref = oidcIssuer
		? `${oidcIssuer}/protocol/openid-connect/auth?client_id=${oidcClientId}&redirect_uri=${encodeURIComponent(`${frontendUrl}/api/auth/callback/oidc`)}&response_type=code&scope=openid%20profile%20email`
		: '/dashboard';

	return (
		<AlertDialog open={alertOpen} onOpenChange={setAlertOpen}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t('title')}</AlertDialogTitle>
					<AlertDialogDescription>
						{t('description')}
						<br />
						<strong>{t('subDescription')}</strong>
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{t('cancelBtn')}</AlertDialogCancel>
					<Link href={signInHref}>
						<AlertDialogAction>{t('loginBtn')}</AlertDialogAction>
					</Link>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
